import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";
import { MATERIALS, MATERIAL_CATEGORIES } from "@/data/materials";
import { Reveal, SectionHead } from "@/components/Reveal";

export default function MaterialsIndex() {
  return (
    <>
      <Helmet>
        <title>Spring Materials | Inconel, Hastelloy, Monel, 17-7PH, Stainless & Alloy Steels | MESCO Springs</title>
        <meta name="description" content="Spring raw material specialists: Inconel X-750/718, Hastelloy C-276, Monel 400/K-500, 17-7PH, 17-4PH, stainless 302/304/316, chrome silicon, chrome vanadium, SUP9, music wire, beryllium copper. Exotic alloy springs manufacturer India." />
      </Helmet>
      <div className="pt-40 pb-16 border-b border-[#334772]/15 blueprint-grid" data-testid="materials-index-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <p className="font-mono-spec text-[11px] tracking-[0.35em] uppercase text-[#334772]">[ RAW MATERIAL LIBRARY ]</p>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl uppercase leading-[0.9] text-[#334772] mt-6">
              Exotic alloys.<br />In stock. Coiled here.
            </h1>
            <p className="mt-6 max-w-2xl text-[#706F70] leading-relaxed">
              The material decides whether a spring survives its service. We stock and coil the full spectrum — from
              music wire to nickel superalloys — with EN 10204 3.1 traceability on every batch.
            </p>
          </Reveal>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 space-y-20">
        {MATERIAL_CATEGORIES.map((cat) => (
          <div key={cat}>
            <SectionHead label={cat} title={cat} />
            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#334772]/10 border border-[#334772]/15">
              {MATERIALS.filter((m) => m.category === cat).map((m, i) => (
                <Reveal key={m.slug} delay={i * 0.08}>
                  <Link
                    to={`/materials/${m.slug}`}
                    data-testid={`material-index-card-${m.slug}`}
                    className="group block bg-[#FFFFFF] p-8 h-full hover:bg-[#F3F5F8] hover:-translate-y-1 transition-all duration-300 border border-transparent hover:border-[#334772]"
                  >
                    <h2 className="font-display text-3xl text-[#334772] uppercase tracking-wide group-hover:text-[#706F70] transition-colors duration-200">{m.name}</h2>
                    <p className="mt-3 text-sm text-[#706F70] leading-relaxed">{m.tagline}</p>
                    <dl className="mt-5 space-y-2">
                      {m.properties.slice(0, 2).map((p) => (
                        <div key={p.label} className="flex justify-between gap-3 border-b border-[#334772]/10 pb-2">
                          <dt className="font-mono-spec text-[10px] uppercase tracking-wider text-[#9C9C9C]">{p.label}</dt>
                          <dd className="font-mono-spec text-[10px] text-[#334772] text-right">{p.value}</dd>
                        </div>
                      ))}
                    </dl>
                    <span className="mt-5 inline-flex items-center gap-2 font-mono-spec text-[10px] tracking-[0.2em] uppercase text-[#334772] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      Full datasheet <ArrowRight className="w-3 h-3" />
                    </span>
                  </Link>
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
